<template>
  <div id="compare">
    <div class="title">
      <img :src="require('../assets/imgs/'+ grade +'/title-banner1-type2.png')" alt />
      <div class="title-inner">
        <b-icon class="title-icon" name="compare" :color="$util.mainTtleColor(grade)" :size="1.2"></b-icon>
        <p class="title-text" :style="{ color: $util.mainTtleColor(grade)}">学习内容对标</p>
      </div>
    </div>
    <div
      style="width: 100%;padding: 1rem;display: flex;justify-content: center;align-items: center;font-weight: 900;color: #eee;"
    >
      <img v-if="imgUrl !== ''&&imgUrl!==null" style="max-width: 100%" :src="imgUrl" alt />
      <img v-else style="max-width: 100%" src="../assets/imgs/stady.jpg" />
    </div>
  </div>
</template>
<script>
export default {
  name: "Compare",
  props: {
    imgUrl: {},
    grade: {
      default: 6
    }
  },
  data() {
    return {};
  }
};
</script>
<style lang="scss">
#compare {
  width: 100%;
  background: #fff;
  > .title {
    width: 100%;
    height: 280px;
    /*font-size: 0;*/
    position: relative;
    > img {
      width: 100%;
      height: 100%;
    }
    > .title-inner {
      position: absolute;
      top: 0;
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      padding-left: 5%;
      font-size: 1.2rem;
      color: #7f4224;
      > .title-icon {
        font-size: inherit;
        margin-right: 50px;
      }
      > .title-text {
        font-size: inherit;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Compare.vue